// Copyright (c) 2022 by Move Closer

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'

import { AllowedColor, ModuleBase, ModuleFactory } from '../../contexts'
import { Theme, Variant } from '../../dsl/atoms/Button'

import { AvailableModuleDriver } from '../allowed'
import { ButtonModule, ButtonModuleContent } from './Button.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const buttonContentFactory = (): ButtonModuleContent => ({
  color: AllowedColor.Body,
  link: null,
  theme: Theme.Primary,
  variant: Variant.Full,
  decorator: ''
})

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const buttonFactory: ModuleFactory<ButtonModule> = {
  ...abstractModuleFactory,
  createModule (): ModuleBase<ButtonModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: buttonContentFactory(),
      driver: AvailableModuleDriver.Button
    }
  }
}
